webpackJsonp([126727566583207],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatenschutzPage = function DatenschutzPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Datenschutz'
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'bg-light' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'align-items-center pt-5 pt-lg-7' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Datenschutz.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'py-5 pt-lg-7 pb-lg-5' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '4' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-uppercase' },
	              'Anbieter und Verantwortlicher'
	            ),
	            _react2.default.createElement(
	              'address',
	              null,
	              'Thomas Schmidleithner, BSc',
	              _react2.default.createElement('br', null),
	              'Grolzham 2D',
	              _react2.default.createElement('br', null),
	              '4680 Weibern',
	              _react2.default.createElement('br', null),
	              '\xD6sterreich'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '4' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-uppercase' },
	              'Telefon'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '+43 664 14 555 90'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '4' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-uppercase' },
	              'Email'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:info@serverless.at' },
	                'info@serverless.at'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'pb-7' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'h2',
	              { className: 'mb-3' },
	              'Arten der erhobenen Daten'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Zu den personenbezogenen Daten, die diese Anwendung selbstst\xE4ndig oder durch Dritte verarbeitet, geh\xF6ren: Firma/Projektname, E-Mail, Nachricht, Budgetrahmen, Cookie und Nutzungsdaten.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Vollst\xE4ndige Details zu jeder Art von verarbeiteten personenbezogenen Daten werden in den daf\xFCr vorgesehenen Abschnitten dieser Datenschutzerkl\xE4rung oder durch konkrete Erkl\xE4rungstexte bereitgestellt, die vor der Datenverarbeitung angezeigt werden. Die personenbezogenen Daten k\xF6nnen vom Nutzer freiwillig bereitgestellt oder, im Falle von Nutzungsdaten, automatisch verarbeitet werden, wenn diese Anwendung genutzt wird. Alle durch diese Anwendung angeforderten Daten sind obligatorisch. Sollten diese Daten nicht bereitgestellt werden, kann dies dazu f\xFChren, dass diese Anwendung nicht in der Lage ist, ihre Dienste zur Verf\xFCgung zu stellen. In F\xE4llen, in denen diese Anwendung ausdr\xFCcklich angibt, dass einige Daten nicht obligatorisch sind, d\xFCrfen sich die Nutzer daf\xFCr entscheiden, diese Daten ohne jegliche Folgen f\xFCr die Verf\xFCgbarkeit oder die Funktion des Dienstes nicht weiterzugeben. Nutzer, die sich dar\xFCber im Unklaren sind, welche personenbezogenen Daten obligatorisch sind, k\xF6nnen gerne den Eigent\xFCmer kontaktieren. Jegliche Verwendung von Cookies - oder anderer Tracking-Tools - durch diese Anwendung oder die Besitzer von Drittdiensten, die durch diese Anwendung genutzt werden, dient dem Zweck, den vom Nutzer gew\xFCnschten Dienst bereitzustellen, und allen anderen Zwecken, die im vorliegenden Dokument und, falls vorhanden, in der Cookie-Richtlinie beschrieben sind.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Die Nutzer sind f\xFCr alle personenbezogenen Daten Dritter verantwortlich, die durch diese Anwendung beschafft, ver\xF6ffentlicht oder weitergegeben werden, und best\xE4tigen, dass sie die Zustimmung zur \xDCbermittlung personenbezogener Daten etwaiger Dritter an diese Anwendung eingeholt haben.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Art und Ort der Datenverarbeitung'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Verarbeitungsmethoden'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Die verantwortliche Stelle verarbeitet die Nutzerdaten auf ordnungsgem\xE4\xDFe Weise und ergreift angemessene Sicherheitsma\xDFnahmen, um den unbefugten Zugriff und die unbefugte Weiterleitung, Modifizierung oder Vernichtung von Daten zu vermeiden.',
	              _react2.default.createElement('br', null),
	              'Die Datenverarbeitung wird mittels Computern oder IT-basierten Systemen durchgef\xFChrt, einem organisatorischen Verfahren und Modus folgend die strikt auf die angegebenen Zwecke abzielen. Neben der verantwortlichen Stelle wird m\xF6glicherweise auch bestimmten Kategorien von Verantwortlichen Zugriff auf die Daten gew\xE4hrt, die an der Betreibung der Website beteiligt sind (Personalverwaltung, Vertrieb, Marketing, Recht, Systemadministratoren) oder externen Parteien (wie Fremdanbietern technischer Dienstleistungen, Zustellunternehmen, Hosting-Anbietern, IT-Unternehmen oder Kommunikationsagenturen), die, falls notwendig, vom Eigent\xFCmer als Auftragsverarbeiter eingesetzt werden. Eine aktuelle Liste dieser Beteiligten kann jederzeit von der verantwortlichen Stelle verlangt werden.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Ort'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Die Daten werden am Betriebsort der verantwortlichen Stelle und an allen anderen Orten, an denen sich die mit der Datenverarbeitung beteiligten Parteien befinden, verarbeitet. F\xFCr weitere Informationen, kontaktieren Sie bitte die verantwortliche Stelle.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Speicherdauer'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Die Daten werden so lange gespeichert, wie es f\xFCr das Erbringen der vom Nutzer gew\xFCnschten Dienstleistungen notwendig ist oder f\xFCr die in diesem Dokument aufgef\xFChrten Zwecke angegeben ist. Der Nutzer kann die verantwortliche Stelle jederzeit auffordern, die Daten zu sperren oder zu entfernen.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Nutzung der erhobenen Daten'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' Die Daten \xFCber den Nutzer werden erhoben, damit der Eigent\xFCmer die Dienstleistungen erbringen kann. Dar\xFCber hinaus werden Daten zu folgenden Zwecken erhoben: Kontaktieren des Nutzers, Interaktion mit externen sozialen Netzwerken und Plattformen, Analytik, Verwaltung von Nutzer-Datenbanken, Testen der Performance von Inhalten und Funktionen (A/B-Test), Kommentarfunktion und Erstellen und Verwalten von Sicherungskopien.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Die personenbezogenen Daten, die zu den aufgef\xFChrten Zwecken verwendet werden, sind in den jeweiligen Abschnitten dieses Dokuments aufgef\xFChrt.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Nutzungsdaten'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Informationen, die diese Anwendung (oder Dienste Dritter, die diese Anwendung in Anspruch nimmt), automatisch erhebt, z. B.: die IP-Adressen oder Domain-Namen der Computer von Nutzern, die diese Anwendung verwenden, die URI-Adressen (Uniform Resource Identifier), den Zeitpunkt der Anfrage, die Methode, die f\xFCr die \xDCbersendung der Anfrage an den Server verwendet wurde, die Gr\xF6\xDFe der empfangenen Antwort-Datei, der Zahlencode, der den Status der Server-Antwort anzeigt (erfolgreiches Ergebnis, Fehler etc.), das Herkunftsland, die Funktionen des vom Nutzer verwendeten Browsers und Betriebssystems, die diversen Zeitangaben pro Aufruf (z. B. wie viel Zeit auf jeder Seite der Anwendung verbracht wurde) und Angaben \xFCber den Pfad, dem innerhalb einer Anwendung gefolgt wurde, insbesondere die Reihenfolge der besuchten Seiten, sowie sonstige Informationen \xFCber das Betriebssystem des Ger\xE4ts und/oder die IT-Umgebung des Nutzers.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Ihre Rechte'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Ihnen stehen grunds\xE4tzlich die Rechte auf Auskunft, Berichtigung, L\xF6schung, Einschr\xE4nkung, Daten\xFCbertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verst\xF6\xDFt oder Ihre datenschutzrechtlichen Anspr\xFCche sonst in einer Weise verletzt worden sind, k\xF6nnen Sie sich bei der Aufsichtsbeh\xF6rde beschweren. In \xD6sterreich ist dies die Datenschutzbeh\xF6rde, deren Webseiten Sie unter ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.dsb.gv.at/', 'class': 'external', rel: 'nofollow' },
	                'https://www.dsb.gv.at/'
	              ),
	              ' finden.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'SSL- bzw. TLS-Verschl\xFCsselung'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Wir verwenden zum Schutz Ihrer personenbezognene Daten und anderer vertraulicher Inhalte eine TLS- bzw. SSL-Verschl\xFCsselung. Sie erkennen die Benutzung dieser Absicherung der Daten\xFCbertragung am kleinen Schlo\xDFsymbol oben im Browser und der Verwendung des Schemas https als Teil unserer Internetadresse.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Cookies'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Unsere Website verwendet HTTP-Cookies um nutzerspezifische Daten zu speichern.'
	            ),
	            'Ein Cookie ist ein kurzes Datenpaket, welches zwischen Webbrowser und Webserver ausgetauscht wird, f\xFCr diese aber v\xF6llig bedeutungslos ist und erst f\xFCr die Webanwendung, z. B. einen Online-Shop, eine Bedeutung erh\xE4lt, etwa den Inhalt eines virtuellen Warenkorbes.',
	            _react2.default.createElement('br', null),
	            'Es gibt zwei Arten von Cookies: Erstanbieter-Cookies werden von unserer Website erstellt, Drittanbieter-Cookies werden von anderen Websites (z. B. Google Analytics) erstellt.',
	            _react2.default.createElement('br', null),
	            'Man unterscheidet drei Kategorien von Cookies: unbedingt notwendige Cookies um grundlegende Funktionen der Website sicherzustellen, funktionelle Cookies um die Leistung der Webseite sicherzustellen und zielorientierte Cookies um das Benutzererlebnis zu verbessern.',
	            _react2.default.createElement('br', null),
	            'Wir nutzen Cookies, um unsere Webseite nutzerfreundlicher zu gestalten. Einige Cookies bleiben auf Ihrem Endger\xE4t gespeichert, bis Sie diese l\xF6schen. Sie erm\xF6glichen es uns, Ihren Browser beim n\xE4chsten Besuch wiederzuerkennen.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Wenn Sie dies nicht w\xFCnschen, so k\xF6nnen Sie Ihren Browser so einrichten, dass er Sie \xFCber das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben.',
	              _react2.default.createElement('br', null),
	              'Sie k\xF6nnen jederzeit Cookies, die sich bereits auf Ihrem Computer befinden, l\xF6schen oder Cookies deaktivieren. Die Vorgangsweise dazu ist nach Browser unterschiedlich, am besten Sie suchen die Anleitung in Google mit dem Suchbegriff \u201Ecookies l\xF6schen chrome\u201C oder \u201Ecookies deaktivieren chrome\u201C im Falle eines Chrome Browsers oder tauschen das Wort \u201Echrome\u201C gegen den Namen Ihres Browsers, z. B. edge, firefox, safari aus.',
	              _react2.default.createElement('br', null),
	              'Wenn Sie uns generell nicht gestatten, Cookies zu nutzen, d.h. diese per Browsereinstellung deaktivieren, k\xF6nnen manche Funktionen und Seiten nicht wie erwartet funktionieren.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Google Analytics Datenschutzerkl\xE4rung'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Wir verwenden auf dieser Webseite Google Analytics der Firma Google Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) um Besucherdaten statistisch auszuwerten. Dabei verwendet Google Analytics zielorientierte Cookies.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'N\xE4here Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.google.com/analytics/terms/de.html', 'class': 'external', rel: 'nofollow' },
	                'http://www.google.com/analytics/terms/de.html'
	              ),
	              ' bzw. unter ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://support.google.com/analytics/answer/6004245?hl=de', 'class': 'external', rel: 'nofollow' },
	                'https://support.google.com/analytics/answer/6004245?hl=de'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Pseudonymisierung'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Unser Anliegen im Sinne der DSGVO ist die Verbesserung unseres Angebotes und unseres Webauftritts. Da uns die Privatsph\xE4re unserer Nutzer wichtig ist, werden die Nutzerdaten pseudonymisiert.\xA0Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des \xA7 96 Abs 3 TKG sowie des Art 6 EU-DSGVO Abs 1 lit a (Einwilligung) und/oder f (berechtigtes Interesse) der DSGVO.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Deaktivierung der Datenerfassung durch Google Analytics'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Mithilfe des ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Browser-Add-ons zur Deaktivierung'
	              ),
	              ' von Google Analytics-JavaScript (ga.js, analytics.js, dc.js) k\xF6nnen Website-Besucher verhindern, dass Google Analytics ihre Daten verwendet.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Sie k\xF6nnen die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verf\xFCgbare Browser-Plugin herunterladen und installieren: ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://tools.google.com/dlpage/gaoptout?hl=de', 'class': 'external', rel: 'nofollow' },
	                'https://tools.google.com/dlpage/gaoptout?hl=de'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Google Analytics IP-Anonymisierung'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von Google Analytics implementiert.\xA0Diese Funktion wurde von Google entwickelt, damit diese Webseite die geltenden Datenschutzbestimmungen und Empfehlungen der lokalen Datenschutzbeh\xF6rden einhalten kann, wenn diese eine Speicherung der vollst\xE4ndigen IP-Adresse untersagen. Die Anonymisierung bzw. Maskierung der IP findet statt, sobald die IP-Adressen im Google Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine Speicherung oder Verarbeitung der Daten stattfindet.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Mehr Informationen zur IP-Anonymisierung finden Sie auf\xA0',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://support.google.com/analytics/answer/2763052?hl=de', target: '_blank', rel: 'noopener nofollow', 'class': 'external' },
	                'https://support.google.com/analytics/answer/2763052?hl=de'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'mt-5' },
	              'Google Fonts Datenschutzerkl\xE4rung'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Wir verwenden Google Fonts der Firma Google Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) auf unserer Webseite. Die Verwendung von Google Fonts erfolgt ohne Authentisierung und es werden keine Cookies and die Google Fonts API gesendet. Sollten Sie ein Konto bei Google haben, werden keine Ihrer Google-Kontodaten an Google w\xE4hrend der Nutzung von Google Fonts \xFCbermittelt. Google erfasst lediglich die Nutzung von CSS und der verwendeten Fonts und speichert diese Daten sicher. Mehr zu diesen und weiteren Fragen finden Sie auf ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://developers.google.com/fonts/faq', 'class': 'external', rel: 'nofollow' },
	                'https://developers.google.com/fonts/faq'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Welche Daten von Google erfasst werden und wof\xFCr diese Daten verwendet werden, k\xF6nnen Sie auf ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.google.com/intl/de/policies/privacy/', 'class': 'external', rel: 'nofollow' },
	                'https://www.google.com/intl/de/policies/privacy/'
	              ),
	              ' nachlesen.'
	            ),
	            _react2.default.createElement(
	              'i',
	              { className: 'small' },
	              'Quelle: Teilweise adaptiert vom Datenschutz Generator von firmenwebseiten.at'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = DatenschutzPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-datenschutz-js-830838dcdfc3c5035d27.js